import { useContext } from "react";
import { Step as MuiStep, StepLabel, Stepper as MuiStepper, Typography } from "@mui/material";
import { AppContext, FormData } from "../App";
import { StepKey } from "../constants/steps";

const OPTIONAL_PREFERENCES_MAP = {
  providerModalities: "Modality",
  providerGender: "Gender",
  providerLanguage: "Language",
  providerCertifications: "Program Certification",
};

export function Stepper() {
  const { activeSteps, currentStep, setCurrentStep, form, selectedOptionalPreferences } = useContext(AppContext);

  const handleStepClick = (index: number) => {
    if (index <= currentStep) {
      setCurrentStep(index);
    }
  };

  const renderStepValue = (form: FormData, stepKey: StepKey) => {
    if (stepKey === "providerDeliveryOptions") {
      return (
        <>
          <Typography>{form.providerDeliveryOptions}</Typography>
          <Typography>{form.formattedAddress}</Typography>
        </>
      );
    } else if (stepKey === "optionalPreferences") {
      if (selectedOptionalPreferences.length) {
        return selectedOptionalPreferences.map((preference) => (
          <Typography key={preference}>{OPTIONAL_PREFERENCES_MAP[preference]}</Typography>
        ));
      } else if (form.providerClinicalSpecialties.length) {
        return <Typography>None Selected</Typography>;
      } else {
        return null;
      }
    } else if (stepKey === "providerCertifications") {
      const value = form[stepKey] === "focus" ? "ILS" : form[stepKey].toUpperCase();
      return <Typography>{value}</Typography>;
    } else if (stepKey === "additionalInfo") {
      if (form.additionalInfo === null)  {
        return
      }

      return (
        <Typography>
          {form.additionalInfo.length ? "Additional details added." : "No additional details added."}
        </Typography>
      );
    }

    const value = form[stepKey];
    if (!value) return null;

    if (Array.isArray(value)) {
      return value.map((val) => <Typography key={val}>{val}</Typography>);
    }

    return <Typography>{value}</Typography>;
  };

  return (
    <MuiStepper activeStep={currentStep} orientation="vertical" sx={{ overflow: "auto" }}>
      {activeSteps.map(({ label, stepKey }, index) => (
        <MuiStep key={label}>
          <StepLabel onClick={() => handleStepClick(index)}>
            <span style={{ fontSize: "1.2rem", cursor: "pointer" }}>{label}</span>
          </StepLabel>
          {stepKey && renderStepValue(form, stepKey)}
        </MuiStep>
      ))}
    </MuiStepper>
  );
}
